import { useLingui } from "@lingui/react/macro";
import {
  CalendarCheck,
  CalendarClock,
  ClipboardList,
  CreditCard,
  Euro,
  MapPlus,
  MessageCircle,
  User,
} from "lucide-react";
import { useAuth } from "react-oidc-context";
import { useUserDataQuery } from "../api/userApi.ts";
import { useGetDashboardLinkMutation } from "../api/teacherApi.ts";
import { SidebarSection } from "../components/Sidebar.tsx";

export function useMyStudioSections(): SidebarSection[] {
  const { t } = useLingui();
  const auth = useAuth();
  const { data: user } = useUserDataQuery(auth.user?.profile.sub);
  const { mutateAsync: fetchDashboardLink, isPending: isDashboardLinkPending } =
    useGetDashboardLinkMutation();

  const mainSection: SidebarSection = {
    items: [
      {
        key: "dashboard",
        icon: ClipboardList,
        label: t`Dashboard`,
        path: "dashboard",
      },
      {
        key: "messages",
        icon: MessageCircle,
        label: t`Messages`,
        path: "messages",
      },
      {
        key: "user",
        icon: User,
        label: t`Edit Profile`,
        path: "profile",
      },
      {
        key: "bookings",
        icon: CalendarCheck,
        label: t`My Bookings`,
        path: "bookings",
      },
    ],
  };

  const backstageSection: SidebarSection = {
    label: t`Backstage`,
    items: [
      {
        key: "teacher-dashboard",
        icon: ClipboardList,
        label: t`Teacher Dashboard`,
        path: "teacher-dashboard",
      },
      {
        key: "locations",
        icon: MapPlus,
        label: t`Teaching Locations`,
        path: "locations",
      },
      {
        key: "schedules",
        icon: CalendarClock,
        label: t`Teaching Schedules`,
        path: "schedules",
      },
      {
        key: "prices",
        icon: Euro,
        label: t`Lesson Prices`,
        path: "prices",
      },
    ],
    actionItems: [
      {
        key: "psp-dashboard",
        icon: CreditCard,
        label: t`Payment Dashboard`,
        onAction: async () => {
          const newWindow = window.open("", "_blank");
          const { url } = await fetchDashboardLink();
          if (newWindow) {
            newWindow.location.href = url;
          }
        },
        isLoading: isDashboardLinkPending,
        isExternal: true,
      },
    ],
  };

  return user?.teacherStatus ? [mainSection, backstageSection] : [mainSection];
}
